// Fotos de banco de imagem usadas nos cards animados da seção de soluções,
// sem relação com cliente real.
const avatar = (n: number) =>
  `/landing-page/solutions/avatars/cliente-crediario-exemplo-${n}.webp`;

// Ordem alternada para os rostos não se repetirem lado a lado.
export const SOLUTION_AVATARS = [1, 4, 2, 6, 5, 7, 3, 8].map(avatar);
